import { IResortStrengths } from '@/api/resort/types';
import { useOTSTranslation } from '@/i18n/useOTSTranslation';
import { NextLink } from '@/components/blocks/NextLink';
import { Routes } from '@/routes';
import { categoryClass, positionClass, linkClass } from './styles';

export const Category = ({
  resortStrengths,
}: {
  resortStrengths: IResortStrengths,
}) => {
  const { t } = useOTSTranslation('common');
  const categories: { [key: string]: string } = {
    overall: t('resort.overview.overallRegion'),
    allMtnTerrain: t('resort.overview.allMtnTerrainIRegion'),
    familyFriendly: t('resort.overview.familyFriendlyRegion'),
    terrainPark: t('resort.overview.terrainParkRegion'),
    beginner: t('resort.overview.beginnerRegion'),
    apresSki: t('resort.overview.apresSkiRegion'),
    smallSkiArea: t('resort.overview.smallSkiAreaRegion'),
    intermediate: t('resort.overview.intermediateRegion'),
    expert: t('resort.overview.expertRegion'),
  };

  return (
    <div className={categoryClass}>
      <span className={positionClass}>
        {t('resort.overview.positionPrefix', { value: resortStrengths.position })}
      </span>
      {` ${categories[resortStrengths.category]} `}
      <NextLink className={linkClass} href={Routes.regionSnowReport(resortStrengths.region)}>
        {resortStrengths.region.title}
      </NextLink>
    </div>
  );
};
